import { ProfileDocument, ProfileDocumentStatus, ProfileDocumentType } from "../common/ProfileDocument";

const MILLISECONDS_TO_DAY = 1000*60*60*24;
const OTHER_EXPIRY_LIMIT = 365; // (MMC, TWIC, PASSPORT) - 1 year
const MEDICAL_CERT_EXPIRY_LIMIT = 183; // (Medical Certificate OR STCW) - 6 months

function checkDocumentExpiration(document: ProfileDocument) {
  const differenceInDays = Math.floor((new Date(document.expirationDate).valueOf() - new Date().valueOf())/(MILLISECONDS_TO_DAY));
  if (document.type === ProfileDocumentType.MEDICAL_CERT
      || document.type === ProfileDocumentType.MMC 
      || document.type === ProfileDocumentType.TWIC 
      || document.type === ProfileDocumentType.PASSPORT) {
    if (differenceInDays <= 0) {
      return ProfileDocumentStatus.EXPIRED;
    }

    if (document.type === ProfileDocumentType.MEDICAL_CERT && differenceInDays <= MEDICAL_CERT_EXPIRY_LIMIT) {
      return ProfileDocumentStatus.EXPIRING_SOON;
    } else if (differenceInDays <= OTHER_EXPIRY_LIMIT) {
      return ProfileDocumentStatus.EXPIRING_SOON;
    }
  }
  return ProfileDocumentStatus.UPLOADED;
}

export default checkDocumentExpiration;